/**
 * Library of simple functions to provide an easy to use interface for
 * performing awkward or verbose tasks in a declarative way.
 */

/**
 * A declarative method to stop mutation of an object within an array,
 * instead returning a new array of objects with the correctly updated key.
 *
 * @param {*} objArr
 * @param {*} arrayKey
 * @param {*} mergeObject
 * @returns
 */
export function mergeArrayObject(objArr, arrayKey, mergeObject) {
    return objArr.map(
        (item, idx) => (
            (idx === arrayKey)
                ? { ...item, ...mergeObject }
                : item
        ),
    );
}

export default {
    mergeArrayObject,
};
